// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for the container */
.AgSalarySlip-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1.5rem;
  min-height: 100vh;
  background-color: #f8fafc;
}

/* Form container */
.AgSalarySlip-form-container {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.AgSalarySlip-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  text-align: center;
  margin-bottom: 1.25rem;
}

.AgSalarySlip-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.AgSalarySlip-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.AgSalarySlip-form-group {
  display: flex;
  flex-direction: column;
}

.AgSalarySlip-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.AgSalarySlip-input {
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.AgSalarySlip-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  outline: none;
}

.AgSalarySlip-submit-button {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  text-align: center;
}

.AgSalarySlip-submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Salary slip container */
.AgSalarySlip-slip-container {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 30px;
  border: 1px solid #e5e7eb;
}

.AgSalarySlip-slip-header {
  text-align: center;
 
}

.AgSalarySlip-slip-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.AgSalarySlip-slip-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.AgSalarySlip-slip-month {
  font-size: 1rem;
  color: #4b5563;
}

.AgSalarySlip-slip-details {
  margin-bottom: 1rem;
}

.AgSalarySlip-employee-info {
  margin-bottom: 1rem;
}

.AgSalarySlip-employee-info p {
  font-size: 0.875rem;
  color: #374151;
  margin-bottom: 0.25rem;
}

.AgSalarySlip-employee-info p strong {
  font-weight: 600;
}

.AgSalarySlip-slip-tables {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.AgSalarySlip-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.AgSalarySlip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  color: #374151;
}

.AgSalarySlip-table td {
  padding: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.AgSalarySlip-table td:nth-child(2) {
  text-align: right;
}

.AgSalarySlip-table .AgSalarySlip-total td {
  font-weight: 600;
  background-color: #f9fafb;
}

.AgSalarySlip-net-salary {
  text-align: right;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.AgSalarySlip-net-salary p {
  font-size: 1rem;
  font-weight: 600;
  color: #3b82f6;
}

.AgSalarySlip-slip-footer {
  text-align: center;
  font-size: 0.875rem;
  color: #4b5563;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.AgSalarySlip-slip-footer p {
  margin: 0.25rem 0;
}

.AgSalarySlip-download-button {
  display: block;
  margin: 1rem auto 0;
  background: linear-gradient(135deg, #10b981, #34d399);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.AgSalarySlip-download-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsive styles */
@media (max-width: 768px) {
  .AgSalarySlip-grid {
    grid-template-columns: 1fr;
  }

  .AgSalarySlip-slip-tables {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .AgSalarySlip-container {
    padding: 1rem;
  }

  .AgSalarySlip-form-container,
  .AgSalarySlip-slip-container {
    padding: 1rem;
  }

  .AgSalarySlip-slip-title {
    font-size: 1.25rem;
  }

  .AgSalarySlip-slip-subtitle {
    font-size: 1rem;
  }
}

/*  */
.AgSalarySlip-table-container {
  margin: 2rem 0;
}

.AgSalarySlip-salary-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.AgSalarySlip-salary-table th,
.AgSalarySlip-salary-table td {
  border: 1px solid #ccc;
  padding: 0.75rem;
  text-align: left;
}

.AgSalarySlip-salary-table th {
  background-color: #f2f2f2;
}

.AgSalarySlip-action-button {
  padding: 0.4rem 0.7rem;
  margin-right: 0.3rem;
  border: none;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}

.AgSalarySlip-action-button.show {
  background-color: #3498db;
}

.AgSalarySlip-action-button.edit {
  background-color: #f39c12;
}

.AgSalarySlip-action-button.delete {
  background-color: #e74c3c;
}

.relieving_company_logo_container {
  background: transparent !important;
  background-color: transparent !important;
  padding: 0;
  margin: 0;
}

.relieving_company_logo {
  background: transparent !important;
  mix-blend-mode: multiply; /* makes white image background blend into the page */
  display: block;
}

/* Also check the parent header sections, they may carry the color */
.relieving_header_section,
.AgSalarySlip-slip-header,
.Print_section {
   background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/latters/AgSalary.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;EACxC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,KAAK;AACL;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,wBAAwB,EAAE,qDAAqD;EAC/E,cAAc;AAChB;;AAEA,oEAAoE;AACpE;;;GAGG,gBAAgB;AACnB","sourcesContent":["/* Base styles for the container */\n.AgSalarySlip-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  min-height: 100vh;\n  background-color: #f8fafc;\n}\n\n/* Form container */\n.AgSalarySlip-form-container {\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.AgSalarySlip-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e293b;\n  text-align: center;\n  margin-bottom: 1.25rem;\n}\n\n.AgSalarySlip-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.AgSalarySlip-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.AgSalarySlip-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.AgSalarySlip-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.AgSalarySlip-input {\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.AgSalarySlip-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n  outline: none;\n}\n\n.AgSalarySlip-submit-button {\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0.25rem;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  text-align: center;\n}\n\n.AgSalarySlip-submit-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Salary slip container */\n.AgSalarySlip-slip-container {\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  border: 1px solid #e5e7eb;\n}\n\n.AgSalarySlip-slip-header {\n  text-align: center;\n \n}\n\n.AgSalarySlip-slip-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.25rem;\n}\n\n.AgSalarySlip-slip-subtitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.AgSalarySlip-slip-month {\n  font-size: 1rem;\n  color: #4b5563;\n}\n\n.AgSalarySlip-slip-details {\n  margin-bottom: 1rem;\n}\n\n.AgSalarySlip-employee-info {\n  margin-bottom: 1rem;\n}\n\n.AgSalarySlip-employee-info p {\n  font-size: 0.875rem;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.AgSalarySlip-employee-info p strong {\n  font-weight: 600;\n}\n\n.AgSalarySlip-slip-tables {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.AgSalarySlip-section-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n}\n\n.AgSalarySlip-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.AgSalarySlip-table td {\n  padding: 0.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.AgSalarySlip-table td:nth-child(2) {\n  text-align: right;\n}\n\n.AgSalarySlip-table .AgSalarySlip-total td {\n  font-weight: 600;\n  background-color: #f9fafb;\n}\n\n.AgSalarySlip-net-salary {\n  text-align: right;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 0.75rem;\n}\n\n.AgSalarySlip-net-salary p {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #3b82f6;\n}\n\n.AgSalarySlip-slip-footer {\n  text-align: center;\n  font-size: 0.875rem;\n  color: #4b5563;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 0.75rem;\n}\n\n.AgSalarySlip-slip-footer p {\n  margin: 0.25rem 0;\n}\n\n.AgSalarySlip-download-button {\n  display: block;\n  margin: 1rem auto 0;\n  background: linear-gradient(135deg, #10b981, #34d399);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0.25rem;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.AgSalarySlip-download-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .AgSalarySlip-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .AgSalarySlip-slip-tables {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 576px) {\n  .AgSalarySlip-container {\n    padding: 1rem;\n  }\n\n  .AgSalarySlip-form-container,\n  .AgSalarySlip-slip-container {\n    padding: 1rem;\n  }\n\n  .AgSalarySlip-slip-title {\n    font-size: 1.25rem;\n  }\n\n  .AgSalarySlip-slip-subtitle {\n    font-size: 1rem;\n  }\n}\n\n/*  */\n.AgSalarySlip-table-container {\n  margin: 2rem 0;\n}\n\n.AgSalarySlip-salary-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.AgSalarySlip-salary-table th,\n.AgSalarySlip-salary-table td {\n  border: 1px solid #ccc;\n  padding: 0.75rem;\n  text-align: left;\n}\n\n.AgSalarySlip-salary-table th {\n  background-color: #f2f2f2;\n}\n\n.AgSalarySlip-action-button {\n  padding: 0.4rem 0.7rem;\n  margin-right: 0.3rem;\n  border: none;\n  border-radius: 4px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.AgSalarySlip-action-button.show {\n  background-color: #3498db;\n}\n\n.AgSalarySlip-action-button.edit {\n  background-color: #f39c12;\n}\n\n.AgSalarySlip-action-button.delete {\n  background-color: #e74c3c;\n}\n\n.relieving_company_logo_container {\n  background: transparent !important;\n  background-color: transparent !important;\n  padding: 0;\n  margin: 0;\n}\n\n.relieving_company_logo {\n  background: transparent !important;\n  mix-blend-mode: multiply; /* makes white image background blend into the page */\n  display: block;\n}\n\n/* Also check the parent header sections, they may carry the color */\n.relieving_header_section,\n.AgSalarySlip-slip-header,\n.Print_section {\n   background: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
